export class AudioBufferCache {
  private readonly cap: number
  private readonly map = new Map<string, AudioBuffer>()

  constructor(cap = 12) {
    this.cap = cap
  }

  get size(): number {
    return this.map.size
  }

  has(key: string): boolean {
    return this.map.has(key)
  }

  get(key: string): AudioBuffer | undefined {
    const value = this.map.get(key)
    if (value !== undefined) {
      // Re-insert to mark most-recently-used
      this.map.delete(key)
      this.map.set(key, value)
    }
    return value
  }

  set(key: string, value: AudioBuffer): void {
    if (this.map.has(key)) {
      this.map.delete(key)
    } else if (this.map.size >= this.cap) {
      const oldest = this.map.keys().next().value
      if (oldest !== undefined) this.map.delete(oldest)
    }
    this.map.set(key, value)
  }

  clear(): void {
    this.map.clear()
  }
}

// Module-level shared cache (engine and fetcher both use this instance).
export const audioBufferCache = new AudioBufferCache(12)
